import {
  calculateLineAmount,
  formatMoney,
  formatQuantity,
  formatRate,
} from "../utils/invoiceMath";

export default function InvoiceItemsTable({ items, currencySymbol, startIndex = 0 }) {
  return (
    <table className="invoice-items-table">
      <thead>
        <tr>
          <th>Unit</th>
          <th>Description</th>
          <th>Rate</th>
          <th>Qty.</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => {
          const amount = calculateLineAmount(item);
          const quantity = `${formatQuantity(item.quantity)}${item.unit ? ` ${item.unit}` : ""}`;

          return (
            <tr key={item.id}>
              <td>{startIndex + index + 1}.</td>
              <td>{item.description || "Item description"}</td>
              <td>
                {currencySymbol} {formatRate(item.rate)}
              </td>
              <td>{quantity}</td>
              <td>
                {currencySymbol} {formatMoney(amount)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
